import base from '../dr-base'
import drListView from './dr-list-view.vue'

const schema = {
  $Type: 'dr-list-view',
  name: 'ListView',
  group: 'Data widgets',
  icon: 'list-ul',
  ...base,
  properties: {
    ...base.properties,
    Group: {
      name: 'vuetifyWidgets.dr-list-view.group',
      type: 'any',
      component: 'dr-list-view-group-picker'
    },
    Caption: {
      name: 'vuetifyWidgets.dr-list-view.caption',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drListView,
  propEditors: [
    {
      name: 'dr-list-view-group-picker'
    }
  ]
}

